var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 46,
    viewBox: "0 0 45 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1762 11.4965L30.7254 8.1742V5.36375H34.1762V11.4965ZM44.071 21.0208L36.4472 13.6816V4.69533C36.4472 3.79706 35.7271 3.0666 34.8417 3.0666H29.8996C29.1029 3.0666 28.4552 3.72444 28.4552 4.53105V5.98845L23.55 1.26723C23.2655 0.993661 22.8916 0.842773 22.5 0.842773C22.1077 0.842773 21.7345 0.993661 21.45 1.26723L0.930504 21.0201C0.48142 21.4501 0.459427 22.1743 0.880133 22.6333C1.09439 22.8667 1.39661 22.9999 1.71161 22.9999C2.00462 22.9999 2.28272 22.8871 2.49485 22.6833L22.5 3.42689L42.5052 22.6826C42.7166 22.8871 42.9954 22.9999 43.2877 22.9999C43.6027 22.9999 43.9057 22.8667 44.1206 22.6333C44.5399 22.175 44.5186 21.4509 44.071 21.0208Z",
    fill: "#F57F20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2831 43.312H17.2447V27.0084C17.2447 26.9352 17.306 26.874 17.3785 26.874H27.1494C27.2219 26.874 27.2831 26.9352 27.2831 27.0084V43.312ZM37.9249 43.312H29.5551V27.0084C29.5551 25.6674 28.4779 24.5789 27.1494 24.5789H17.3785C16.05 24.5789 14.9728 25.6674 14.9728 27.0084V43.312H6.60298V18.7571H4.35001V43.7159C4.35001 44.7724 5.19769 45.6285 6.24321 45.6285H38.2847C39.3309 45.6285 40.1786 44.7724 40.1786 43.7159V18.7571H37.9249V43.312Z",
    fill: "#F57F20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.905077ac892950135016e033a45b48ca.svg";
export { ForwardRef as ReactComponent };